// Putting what a lesson needs onto Meal Hat's shopping list.
//
// Meal Hat's model: `grocery-catalog` is the one food record per id, and
// `shopping-list` rows reference a grocery BY ID, never by name. So adding
// "shallot" means: find the catalog entry (by name or alias) or create one,
// then add a row for it unless an unpurchased row is already there. Rows
// carry `source: 'lesson'` and `lessonId`, so Meal Hat can tell them from
// its own and a lesson can find its rows again.
//
// Never removes anything. Meal Hat's own rule: nothing leaves the list
// without a deliberate tap.
import { dbPut } from '../store/db.js';
import { catalogEntryFor, shoppingRowFor } from './inHouse.js';

const uuid = () => (globalThis.crypto?.randomUUID ? globalThis.crypto.randomUUID() : `${Date.now()}-${Math.random().toString(16).slice(2)}`);

/** Meal Hat's own id shape for a catalog entry it creates in-app. */
export const newGroceryId = () => `${Date.now()}-${uuid()}`;

export function planShoppingAdditions (ingredients, { catalog = {}, shoppingList = {} } = {}) {
  const additions = [];
  for (const ingredient of ingredients) {
    if (ingredient.status !== 'need') continue;
    const entry = catalogEntryFor(ingredient, catalog);
    if (entry && shoppingRowFor(entry.id, shoppingList)) continue;
    additions.push({ ingredient, entry });
  }
  return additions;
}

/**
 * Writes the rows. Returns what it wrote, so the screen can say so and the
 * next assessment sees them as 'listed'.
 */
export async function addToShoppingList (hat, lessonId, additions, { catalog = {} } = {}) {
  const written = { catalog: {}, rows: {} };
  for (const { ingredient, entry } of additions) {
    let grocery = entry;
    if (!grocery) {
      const id = newGroceryId();
      grocery = { id, name: ingredient.name, defaultUnits: '', defaultAisle: 0, defaultLocation: null };
      await dbPut(`${hat}/grocery-catalog/${id}`, grocery);
      written.catalog[id] = grocery;
      catalog[id] = grocery;
    }
    const rowId = uuid();
    const row = {
      id: rowId,
      groceryId: grocery.id,
      quantity: 1,
      units: grocery.defaultUnits || '',
      aisle: grocery.defaultAisle || 0,
      location: grocery.defaultLocation || null,
      source: 'lesson',
      lessonId,
      note: ingredient.qty || '',
      purchased: false
    };
    await dbPut(`${hat}/shopping-list/${rowId}`, row);
    written.rows[rowId] = row;
  }
  return written;
}
